<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row class="mb-3">
          <b-col cols="6" class="mt-1">
            <h4>{{ $t('global.roles_list_title') }}</h4>
          </b-col>
          <b-col cols="6">
            <div class="pull-right">
              <b-button variant="primary" class="mt-1" :to="{ name: 'RoleCreate' }">
                {{ $t('global.role_create_new') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col cols="12">
              <b-table class="table-sm text-center" responsive bordered
                :fields="tableFields" :items="tableItems">
                <template v-slot:cell(options)="row">
                  <router-link :to="{ name: 'RoleUpdate', params:{id: row.item.id}}">
                    <a><i class="fa fa-edit fa-lg"/></a>
                  </router-link>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator-->
            <b-col cols="12" v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VT from '@/store/types';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      tableFields: [
        { key: 'id', label: this.$t('global.id') },
        { key: 'name', label: this.$t('global.name') },
        { key: 'created_at', label: this.$t('global.created_at') },
        { key: 'updated_at', label: this.$t('global.updated_at') },
        { key: 'options', label: this.$t('global.options') }
      ],
      tableItems: []
    };
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters('Roles', [
      'rolesList',
    ]),
    listPaginator() {
      return this.rolesList.data.meta;
    },
    list() {
      return this.rolesList;
    }
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    list: {
      handler: function () {
        if (this.list['status'] === statuses.LOADED) {
          this.tableItems = this.list.data.data || [];
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Roles', [
      VT.ROLES_LIST,
    ]),
    getData() {
      this.ROLES_LIST(this.page);
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'Roles', params: { page } });
      }
    },
  }
};

</script>

<style scoped>
</style>
